export const images = {
    tunnel: require('../images/welcome/tunnel.svg'),
    geology: require('../images/welcome/geology.svg'),
    engineering: require('../images/welcome/Engineering.png'),
   circular_tunnel: require('../images/welcome/circular_tunnel.png'),
   shaft: require('../images/welcome/shaft.png'),
   d_tunnel: require('../images/welcome/d_tunnel.png'),
   horse_shoe_tunnel: require('../images/welcome/horse_shoe_tunnel.png'),
   center_line: require('../images/orientation/center_line.png'),
   left_invert: require('../images/orientation/left_invert.png'),
   right_invert: require('../images/orientation/right_invert.png'),
   left_spl: require('../images/orientation/left_spl.png'),
   right_spl: require('../images/orientation/right_spl.png'),
   other: require('../images/orientation/other.png'),
   hscenter_line: require('../images/orientation/HS_center_line.png'),
   hsleft_invert: require('../images/orientation/HS_left_invert.png'),
   hsright_invert: require('../images/orientation/HS_right_invert.png'),
   hsleft_spl: require('../images/orientation/HS_left_spl.png'),
   hsright_spl: require('../images/orientation/HS_right_spl.png'),
   hsother: require('../images/orientation/HS_other.png'),
   circle_right_spl: require('../images/orientation/circle_right_spl.png'),
   circle_left_spl: require('../images/orientation/circle_left_spl.png'),
   circle_center_line: require('../images/orientation/circle_center_line.png'),
};